import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AlertSeverityComponent } from '../../../alerts/components/alert-severity/alert-severity.component';
import { GatewayIconComponent } from '../../../shared/components/gateway-icon/gateway-icon.component';
import { IconComponent } from '../../../shared/components/icons/icon/icon.component';
import { FormatPipe } from '../../../shared/pipes/format.pipe';
import { useFavorites } from '../../composables/use-favorites';
import { FavoriteOID } from '../../models/favorite';
import { FavoriteSite } from '../../models/favorite-site';

@Component({
    selector: 'app-favorite-item',
    imports: [GatewayIconComponent, AlertSeverityComponent, IconComponent, FormatPipe, RouterLink, TranslatePipe],
    templateUrl: './favorite-item.component.html',
    styleUrl: './favorite-item.component.scss',
})
export class FavoriteItemComponent {
    private readonly favorites = useFavorites();

    readonly favoriteSite = input.required<FavoriteSite>();
    readonly editMode = input(false);

    onDeleteFavorite($event: Event, favoriteOID: FavoriteOID): void {
        $event.stopPropagation();
        $event.preventDefault();

        this.favorites.removeFavorite(favoriteOID);
    }
}
